async function initRecentlyViewed() {
  const section = document.querySelector('.recently-viewed-section');

  if (!section || section.dataset.initialized === 'true') return;

  section.dataset.initialized = 'true';

  const currentProduct = Number(section.dataset.currentProduct);
  const limit = Number(section.dataset.limit);
  const wrapper = document.getElementById('recently-viewed-grid');

  if (!wrapper) return;

  let viewed = JSON.parse(
    localStorage.getItem('recentlyViewedProducts') || '[]'
  );

  viewed = viewed
    .filter(item => item.id !== currentProduct)
    .slice(0, limit);

  if (!viewed.length) {
    section.style.display = 'none';
    return;
  }

  try {
    const responses = await Promise.all(
      viewed.map(item =>
        fetch(`/products/${item.handle}?view=recently-viewed`)
      )
    );

    const htmls = await Promise.all(
      responses.map(res => res.text())
    );

    wrapper.innerHTML = htmls
      .map(html => `<div class="swiper-slide">${html}</div>`)
      .join('');

    if (wrapper.children.length) {
      new Swiper('.recently-viewed-swiper', {
        slidesPerView: 4,
        spaceBetween: 20,

        navigation: {
          nextEl: '.recently-viewed-swiper .swiper-button-next',
          prevEl: '.recently-viewed-swiper .swiper-button-prev'
        },

        breakpoints: {
          0: {
            slidesPerView: 1.2
          },
          480: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          990: {
            slidesPerView: 4
          }
        }
      });
    }
  } catch (error) {
    console.error('Recently Viewed Error:', error);
  }

  try {
       if(typeof iWish!=='undefined'){
         setTimeout(function(){
           iWish.checkIwishColl();
         },1500)
       }
     } catch (error) {
  }
}

/* Run immediately if DOM already exists */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
} else {
  initRecentlyViewed();
}

/* Run again after full page load */
window.addEventListener('load', initRecentlyViewed);

/* Shopify Theme Editor Support */
document.addEventListener('shopify:section:load', initRecentlyViewed);